import {
	useShowOnboardingWizardScreen,
	useShowOnboardingWizardScreenForScrum,
	useShowOnboardingWizardScreenForKanban,
	useShowOnboardingWizardScreenForRouteBiz,
} from '../controllers';

export const useIsWizardVariation = ({
	updatedStatsigClientWithCloudId,
}: {
	updatedStatsigClientWithCloudId: boolean;
}) => {
	const { userEligibleForWizardExperiment } = useShowOnboardingWizardScreen();
	const { userEligibleForWizardForScrumExperiment } = useShowOnboardingWizardScreenForScrum();
	const { userEligibleForWizardForKanban } = useShowOnboardingWizardScreenForKanban();
	const { userEligibleForWizardForRouteBizExperiment } = useShowOnboardingWizardScreenForRouteBiz();

	if (!updatedStatsigClientWithCloudId) {
		return { isWizardVariation: false };
	}

	if (userEligibleForWizardExperiment) {
		return { isWizardVariation: true };
	}

	if (userEligibleForWizardForRouteBizExperiment) {
		return { isWizardVariation: true };
	}

	if (userEligibleForWizardForScrumExperiment) {
		return { isWizardVariation: true };
	}

	if (userEligibleForWizardForKanban) {
		return { isWizardVariation: true };
	}

	return { isWizardVariation: false };
};
